export const SAVE_OFFER_DRAFT = 'OFFER :: SAVE_DRAFT';

export type TSaveOfferDraftAction = {
  type: typeof SAVE_OFFER_DRAFT;
};

export function saveOfferDraft(): TSaveOfferDraftAction {
  return {
    type: SAVE_OFFER_DRAFT,
  };
}
